import { Component, OnDestroy } from '@angular/core';
import { ArrivePlanService } from '../../../service/arrive-plan/arrive-plan.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: 'wa1000.component.html',
  styleUrls: ['wa1000.component.scss']
})
export class Wa1000Component implements OnDestroy {
  public componentTitle = 'WA1000:入荷データアップロード';

  public owners;
  public owner;
  public working = false;
  private errorInfo = '';
  private openTable: boolean = false;
  private timer;
  public ownerId: number;
  public ownerResult: any;


  constructor(
    private arrivePlanService: ArrivePlanService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private router: Router
  ) {

    if (sessionStorage.getItem('ownerResult') !== null) {
      const selectedOwner = JSON.parse(sessionStorage.getItem('ownerResult'));
      this.ownerId = selectedOwner.ownerId;
    }

    if (this.ownerId === undefined) {
      this.ownerService
        .get()
        .then(outputJson => {
          this.owners = outputJson.owners;
          this.owner = undefined;
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.owner = JSON.parse(sessionStorage.getItem('ownerResult'));
      this.owners = [];
    }

    this.timer = setInterval(() => {
      document.getElementById('currentDate').innerHTML = this.getNow();
    }, 1000);
  }

  getNow() {
    var dateObj = new Date();
    var y = dateObj.getFullYear();
    var m = dateObj.getMonth() + 1;
    var d = dateObj.getDate();
    var hh = dateObj.getHours();
    var mm = ("0" + dateObj.getMinutes()).slice(-2);
    var set1 = "<small>" + y + "/" + m + "/" + d + "</small>" + hh + "<span>:</span>" + mm;
    return set1;
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  changeOwner(e) {
    if (e === undefined) {
      this.ownerService
        .get()
        .then(outputJson => {
          this.owners = outputJson.owners;
          this.owner = undefined;
          return;
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.owner = JSON.parse(sessionStorage.getItem('ownerResult'));
      this.owners = [];
    }
  }

  tableNavClick() {
    if (this.openTable === false) {
      this.openTable = true;
    } else {
      this.openTable = false;
    }
  }

  goFragment(location: string) {
    window.location.hash = '';
    window.location.hash = 'id_' + location;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1000/wa1000.component.ts